export enum OptionOrientation {
  HORIZONTAL = 0,
  VERTICAL = 1
}
